/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import ProductItem from "./ProductItem";
import PluginCardSkeleton from "../../skeleton/PluginCardSkeleton";
import Button from "../../ui/Button";
import Flex from "../../ui/Flex";
import Stack from "../../ui/Stack";

const ProductItemSkeletons = styled(Stack)`
  grid-template-columns: repeat(auto-fill, minmax(min(314px, 100%), 1fr));
`;

const StyledInnerWrapper = styled(Stack)`
  grid-template-columns: repeat(auto-fill, minmax(min(314px, 100%), 1fr));
`;

const LoadMoreWrapper = styled(Flex)`
  margin-top: 1rem;
`;

const ProductGrid = ({
  products, isLoading,
  hasNextPage, isFetchingNextPage, onLoadMore,
  position, selectedProducts,
  handleProductSelect, updateProduct,
  canEditQty = true, addedLabel,
}) => {
  const reserveDescription = products.some((p) => p.description);

  return (
    <>
      {isLoading && !products.length
        ? (
          <ProductItemSkeletons $gap="0.5rem">
            <PluginCardSkeleton />
          </ProductItemSkeletons>
        )
        : (
          <StyledInnerWrapper $gap="0.5rem">
            {products.map((product) => (
              <ProductItem
                key={product.id}
                product={product}
                position={position}
                selectedProducts={selectedProducts}
                handleProductSelect={handleProductSelect}
                updateProduct={updateProduct}
                reserveDescription={reserveDescription}
                canEditQty={canEditQty}
                addedLabel={addedLabel}
              />
            ))}
          </StyledInnerWrapper>
        )}

      {hasNextPage && (
        <LoadMoreWrapper $justify="center">
          <Button title="Load more" variant="secondary" onClick={onLoadMore} disabled={isFetchingNextPage} />
        </LoadMoreWrapper>
      )}
    </>
  );
};

export default ProductGrid;